import React from 'react'
import clsx from 'clsx'
import {type PageTab, PageTabItem} from './PageTabItem/index.ts'
import styles from './PageTabs.module.scss'

export interface PageTabsProps {
    className?: string
    activeTabId: string
    tabs: PageTab[]
    onTabChange: (tabId: string) => void
    compactOnMediumScreensAndBelow?: boolean
    compactMode?: boolean
    switchToHorizontalOnMediumScreensAndBelow?: boolean
    direction?: 'horizontal' | 'vertical'
}

export const PageTabs = ({
    className,
    activeTabId,
    tabs,
    onTabChange,
    compactMode = false,
    compactOnMediumScreensAndBelow = false,
    switchToHorizontalOnMediumScreensAndBelow = false,
    direction = 'vertical',
}: PageTabsProps) => (
    <div className={clsx(styles.pageTabsContainer,
        styles[direction],
        {
            [styles.switchToHorizontalOnMediumScreensAndBelow]: switchToHorizontalOnMediumScreensAndBelow,
            [styles.compactOnMediumScreensAndBelow]: compactOnMediumScreensAndBelow,
            [styles.compactMode]: compactMode,
        },
        className)}>
        {tabs.map((tab) => (
            <PageTabItem
                key={tab.id}
                tab={tab}
                isActive={activeTabId === tab.id}
                isDisabled={!!tab.disabled}
                onClick={() => onTabChange(tab.id)}
                compactMode={compactMode}
                compactOnMediumScreensAndBelow={compactOnMediumScreensAndBelow}
                centered={direction == 'horizontal'}
            />
        ))}
    </div>
)
